import React from 'react'
import PageLayout from '@view/layout/pageLayout/PageLayout'
import Dashboard from '@containers/dashboard/Dashboard'

const DashboardPage = () => {
	return (
		<PageLayout>
			<Dashboard/>
		</PageLayout>
	)
}

export default DashboardPage
